import { render } from "./CheckoutContent.vue?vue&type=template&id=804c6340"
import script from "./CheckoutContent.vue?vue&type=script&lang=js"
export * from "./CheckoutContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__